var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dv-box-1"},[(_vm.title)?_c('div',{staticClass:"dv-title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n        "),_c('div',{staticClass:"decorate"})]):_vm._e(),_c('div',{staticClass:"dv-box-con"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }